import { TableBody, TableCell, TableRow } from '@hulu/react-style-components';
import styled, { css } from 'styled-components';

import { stickyColumn } from '../styled';

export const StyledTableBody = styled(TableBody)(
  ({ theme: { admanColors, spacers } }) => css`
    td {
      font-weight: 400;
      text-align: inherit;
      padding: ${spacers!.spacer02};
      font-family: InspireTWDC;
      font-size: 14px;
      line-height: 21px;
      color: ${admanColors!.gray.dark.bg3[0]};
      height: inherit;
      border-bottom: 1px solid ${admanColors!.gray.light.bg3[2]};
      background-color: inherit;

      &.leftBorder {
        box-shadow: inset 1px 0 2px -1px ${admanColors!.gray.light.bg3[2]};
      }

      &.rightBorder {
        box-shadow: inset -1px 0 2px -1px ${admanColors!.gray.light.bg3[2]};
      }
    }

    tr {
      box-shadow: none;
      vertical-align: top;
    }
  `
);

export const StyledTableCell = styled(TableCell)<{ $left?: number }>(
  ({ theme: { spacers }, $left }) => css`
    padding: ${spacers!.spacer03} 0;

    &.sticky {
      ${stickyColumn}

      left: ${$left ? `${$left}px` : 0};
    }
  `
);

export const StyledTableRow = styled(TableRow)<{ $selected?: boolean }>`
  background-color: ${({ $selected, theme }): string =>
    $selected ? theme.admanColors!.blue.dark.bg1[1] : theme.colors!.colorWhite};
`;
